import React from "react";
import styles from "./FlyoutActions.module.css";

interface Props {
    children: React.ReactNode;
    // applies a gradient to the top of the actions for scrolling
    after?: boolean;
    className?: string;
}

const FlyoutActions = ({ children, after, className }: Props) => (
    <div className={`${styles.flyoutActions} ${after ? styles.flyoutActionsAfter : ""} ${className}`}>{children}</div>
);

export default FlyoutActions;
